import { Component } from "react";
import TopNav from "../components/top_nav";
import Footer from "../components/footer";
import { ArrowRight } from "react-bootstrap-icons";
import SolutionTabs from "../components/solutions_tab_bar";

export default class SolutionsScreen extends Component {
    render() {
        return (
            <div className="">
                <TopNav />

                <section className="position-relative text-white">

                    <div
                        className="position-absolute top-0 start-0 w-100"
                        style={{
                            backgroundImage: 'url("/solutions01.avif")',
                            backgroundSize: 'cover',
                            backgroundPosition: 'center',
                            filter: 'blur(1px) brightness(60%)',
                            zIndex: 0,
                            height: '600px',
                        }}
                    ></div>

                    <div className="container position-relative z-1 py-5">
                        <div
                            className="row py-5"
                        >
                            <div className="col-md-7 ms-md-4">
                                <h1 className="fs-46 fw-bold">
                                    Transforming rail for people, goods, and global progress.
                                </h1>
                            </div>
                            <div className="col-md-5 ms-md-4">
                                <p className="fs-17 mt-4">
                                    Engineering smart rail systems that optimize industrial mobility, rail safety and logistics through automation, data intelligence, and scalable infrastructure.
                                </p>
                            </div>
                        </div>

                        <div className="row bg-white text-dark rounded-4 py-5 justify-content-between mt-5">
                            <div className="col-md-4 px-4">
                                <h4 className="fw-bold fs-46 mb-3">Services</h4>
                                <p className="text-muted mb-0 fs-16">
                                    We provide end-to-end consulting and project management support
                                    for advanced rail systems, with 100% safety as our top priority.
                                    Our expert consultants ensure every project adheres to globally
                                    recognized safety standards through meticulous planning, proven
                                    methodologies, and precision execution. From design to deployment
                                    and maintenance, we integrate safety into every layer, delivering
                                    reliable and future-ready solutions.
                                </p>
                            </div>
                            {/* Products */}
                            <div className="col-md-4 border-start border-end px-4">
                                <h4 className="fw-bold fs-46 mb-3 mt-md-0 mt-4">Products</h4>
                                <p className="text-muted mb-0 fs-16">
                                    Our product suite features advanced rail technologies including
                                    collision avoidance systems, LiDAR-based tracking units, and
                                    intelligent tools for automating design documentation. Built with
                                    a futuristic vision, our solutions enhance safety, precision, and
                                    efficiency across modern rail networks.
                                </p>
                            </div>
                            {/* Solutions */}
                            <div className="col-md-4 px-4">
                                <h4 className="fw-bold fs-46 mb-3 mt-md-0 mt-4">Solutions</h4>
                                <ol className="ps-3 mb-0">
                                    <li className="mb-3">
                                        <a href="#" className="text-primary text-decoration-none fs-16">Advanced Train Collision Avoidance Systems</a>
                                    </li>
                                    <li className="mb-3">
                                        <a href="#" className="text-primary text-decoration-none fs-16">Smart Yard Solutions</a>
                                    </li>
                                    <li className="mb-3">
                                        <a href="#" className="text-primary text-decoration-none fs-16">Operations & Maintenance</a>
                                    </li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </section>



                <div className="container my-5">
                    <div className="  p-md-4 rounded-4">
                        <div className="row align-items-center flex-column flex-lg-row">

                            {/* Text Section */}
                            <div className="col-12 w-38">
                                <span className="badge fw-normal rounded-pill border-primary-blue text-primary-blue px-3 py-1 mb-3 fs-16">
                                    <span className="me-2 text-success fs-16">●</span>Innovation Fueled by Precision
                                </span>
                                <p className="fs-36 fw-bold mb-4" style={{ lineHeight: '1.2' }}>
                                    Technologies Driving Our Innovation
                                </p>
                                <p className="text-primary-blue" style={{ lineHeight: '1.3' }}>
                                    At the core of our operations lies a commitment to harnessing
                                    cutting-edge technologies that drive efficiency, safety, and
                                    scalability. From automation to advanced analytics, our innovations
                                    are built to meet the demands of modern industry
                                </p>
                                <p className="fs-16 text-primary-blue mb-0 fw-bold">
                                    — delivering reliable performance, sustainable growth, and a competitive edge.
                                </p>
                                <button
                                    onClick={() => window.location.href = "innovation"}
                                    className="btn d-flex align-items-center px-1 py-1 rounded-pill text-white mt-4 bg-primary-blue"
                                >
                                    <span className="mx-3 fs-14">Know more</span>
                                    <div
                                        className="d-flex justify-content-center align-items-center rounded-circle"
                                        style={{
                                            width: '35px',
                                            height: '35px',
                                            backgroundColor: '#ffffff',
                                        }}
                                    >
                                        <ArrowRight color="#193E6C" />
                                    </div>
                                </button>
                            </div>

                            {/* Image Section */}
                            <div className="col-12 w-62 text-center px-2 px-md-0 mt-4 mt-lg-0">
                                <img
                                    src="/solutions02.webp"
                                    alt="solutions"
                                    className="img-fluid rounded-4 w-100 h-100"
                                    style={{ objectFit: 'cover' }}
                                />
                            </div>

                        </div>
                    </div>
                </div>
                <div style={{ height: "60px" }}></div>




                <div className="row justify-content-center mx-0 mt-5">
                    <div className="col-12 col-md-10 px-3 px-md-0">
                        <SolutionTabs />
                    </div>
                </div>





                <div className="row justify-content-center mx-0">
                    <div className="col-12 col-md-10 my-5">
                        <div className="row align-items-center bg-white rounded-4 p-3 p-md-4">
                            <h3 className="mb-4 fw-semibold fs-24 px-md-0">Explore Case Studies</h3>

                            <div className="col-12 col-md-5 mb-4 mb-md-0 ps-md-0">
                                <img
                                    src="/discuss.webp"
                                    alt="Discuss"
                                    className="img-fluid rounded-4 w-100"
                                    style={{
                                        objectFit: 'cover',
                                        width: '100%',
                                        height: 'auto',
                                        minHeight: '200px',
                                        maxHeight: '350px',
                                    }}
                                />
                            </div>

                            <div
                                className="col-12 col-md-7 d-flex flex-column justify-content-between ps-md-4"
                                style={{
                                    minHeight: '200px',
                                }}
                            >
                                <div>
                                    <h4 className="fw-bold mb-3 fs-36">
                                        Yard Safety Management Solution Deployment at Large Steel Producer
                                    </h4>
                                </div>
                                <div>
                                    <p className="text-primary-blue mb-3">
                                        Implemented a Robust Yard Safety Management Solution at the Angul plant of a leading
                                        steel producer. The system enhances safety through real-time monitoring, automated
                                        access control, and incident tracking.
                                    </p>
                                    <p className="text-primary-blue fw-bold fs-18">
                                        — Improving compliance, visibility, and operational efficiency in a high-risk industrial
                                        environment.
                                    </p>
                                </div>
                                <div>
                                    <button
                                        onClick={() => window.location.href = "case-studies/case-study"}
                                        className="btn d-flex align-items-center px-1 py-1 rounded-pill text-white bg-primary-blue"
                                    >
                                        <span className="mx-3 fs-14">View Case Study</span>
                                        <div
                                            className="d-flex justify-content-center align-items-center rounded-circle"
                                            style={{
                                                width: '32px',
                                                height: '32px',
                                                backgroundColor: '#ffffff',
                                            }}
                                        >
                                            <ArrowRight color="#193E6C" />
                                        </div>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="container my-5">
                    <div className="bg-grey-color p-4 p-md-5 rounded-4">
                        <div className="row align-items-center">
                            <div className="col-md-6">
                                <h6 className="fs-20 text-primary-blue fw-bold">Meet Our Team</h6>
                                <p className="fs-32 fw-bold mb-1">Let’s Build the Railways of Tomorrow</p>
                                <p className="fs-18">
                                    Whether you’re modernizing legacy infrastructure or pioneering new corridors,
                                    BHEPL is your trusted technology ally. Together, let’s shape the intelligent
                                </p>
                                <button
                                    onClick={() => window.location.href = "contact"}
                                    className="btn d-flex align-items-center px-1 py-1 rounded-pill text-white bg-primary-blue"
                                >
                                    <span className="mx-3 fs-14">Contact us for Strategic Collaboration</span>
                                    <div
                                        className="d-flex justify-content-center align-items-center rounded-circle"
                                        style={{
                                            width: '35px',
                                            height: '35px',
                                            backgroundColor: '#ffffff',
                                        }}
                                    >
                                        <ArrowRight color="#193E6C" />
                                    </div>
                                </button>
                            </div>

                            <div className="col-md-6 d-flex align-items-stretch mt-4 mt-md-0">
                                <img
                                    src="/discuss2.webp"
                                    alt="Discuss"
                                    className="img-fluid rounded-4 shadow-sm w-100"
                                    style={{
                                        objectFit: 'cover',
                                        width: '100%',
                                        height: 'auto',
                                        minHeight: '200px',
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                </div>



                <Footer />
            </div>
        );
    }
}